import { render, staticRenderFns } from "./LeagueStat.vue?vue&type=template&id=87b7b9b8&scoped=true&"
import script from "./LeagueStat.vue?vue&type=script&lang=js&"
export * from "./LeagueStat.vue?vue&type=script&lang=js&"
import style0 from "./LeagueStat.vue?vue&type=style&index=0&id=87b7b9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b7b9b8",
  null
  
)

export default component.exports